const getTheme = () => {
    return {
        container: {},
    };
};

export default getTheme;
